/**
 * Personalization Overlay - AI-style Typing Animation
 *
 * This script creates a typing animation effect on the first product image.
 * The text appears 4 seconds after page load and fades out after 5 seconds.
 *
 * How to customize:
 * - Change text: Edit data-overlay-text attribute in product-thumbnail.liquid
 * - Change position: Edit CSS variables in section-main-product.css
 * - Change timing: Edit DELAY_BEFORE_TYPING and FADE_OUT_DELAY constants below
 */

class PersonalizationOverlay {
  constructor() {
    // TIMING CONFIGURATION - Edit these values to change animation timing
    this.DELAY_BEFORE_TYPING = 2500;    // Wait 2.5 seconds before starting (milliseconds)
    this.TYPING_SPEED = 100;            // Time between each character (milliseconds)
    this.FADE_OUT_DELAY = 3000;         // Wait 3 seconds before fading out (milliseconds)

    this.overlay = null;
    this.textElement = null;
    this.fullText = '';
    this.currentIndex = 0;
    this.typingInterval = null;
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.start());
    } else {
      this.start();
    }
  }

  start() {
    // Find the overlay element (only exists on first product image)
    this.overlay = document.querySelector('.personalization-overlay');

    if (!this.overlay) {
      console.log('Personalization overlay not found - may not be on product page');
      return;
    }

    this.textElement = this.overlay.querySelector('.personalization-overlay__text');
    this.fullText = this.overlay.getAttribute('data-overlay-text') || 'Your Name Here';

    // Start the animation after the configured delay
    setTimeout(() => this.startTyping(), this.DELAY_BEFORE_TYPING);
  }

  startTyping() {
    // Show the overlay container with fade-in
    this.overlay.classList.add('show');

    // Start with lighter color (stamping effect begins)
    this.textElement.classList.add('stamping');

    // Reset text content
    this.textElement.textContent = '';
    this.currentIndex = 0;

    // Start typing animation
    this.typingInterval = setInterval(() => {
      if (this.currentIndex < this.fullText.length) {
        this.textElement.textContent += this.fullText[this.currentIndex];
        this.currentIndex++;
      } else {
        // Typing complete - darken the text (stamp is pressed)
        clearInterval(this.typingInterval);
        this.completeStamp();
      }
    }, this.TYPING_SPEED);
  }

  completeStamp() {
    // Remove stamping class to darken text
    this.textElement.classList.remove('stamping');
    this.textElement.classList.add('stamped');

    // Schedule hide after darken effect
    this.scheduleHide();
  }

  scheduleHide() {
    // Wait for the configured duration, then fade out
    setTimeout(() => {
      this.overlay.classList.remove('show');
      this.overlay.classList.add('hide');
    }, this.FADE_OUT_DELAY);
  }

  // Clean up if needed
  destroy() {
    if (this.typingInterval) {
      clearInterval(this.typingInterval);
    }
    if (this.overlay) {
      this.overlay.classList.remove('show', 'hide');
    }
  }
}

// Initialize the overlay when script loads
const personalizationOverlay = new PersonalizationOverlay();
personalizationOverlay.init();
